import { init as sentryInit } from '@sentry/browser';
import $ from 'jquery';
import _get from 'lodash/get';
var sentryPublicDsn = _get(window, 'cccisd.boilerplate.sentryPublicDsn');
if (!window.Raven && sentryPublicDsn) {
  sentryInit({
    dsn: sentryPublicDsn
  });
}

// Provides with global jQuery with Bootstrap plugin
if (!window.$) {
  window.$ = $;
  window.jQuery = $;
}
require('bootstrap');

// Add polyfill for CustomEvent (for IE11)
(function () {
  if (typeof window.CustomEvent === 'function') return false;
  function CustomEvent(event, params) {
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: undefined
    };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }
  CustomEvent.prototype = window.Event.prototype;
  window.CustomEvent = CustomEvent;
})();

// Add polyfill for performance.now (for iOS Safari)
(function () {
  window.performance = window.performance || {};
  if (!window.performance.now) {
    var nowOffset = Date.now();
    window.performance.now = function () {
      return Date.now() - nowOffset;
    };
  }
})();

// Set up public path for webpack
(function () {
  // Getting the entry script path
  var scripts = document.getElementsByTagName('script');
  var entryScriptFolder;
  for (var i = 0; i < scripts.length; i++) {
    var src = scripts[i].src;
    if (/app.{10,50}\.bundle\.js$/.test(src)) {
      entryScriptFolder = src.substr(0, src.lastIndexOf('/') + 1);
      break;
    }
  }
  if (!entryScriptFolder) {
    console.error('Cannot get information about the entry script');
    return;
  }

  // eslint-disable-next-line camelcase, no-undef
  __webpack_public_path__ = entryScriptFolder;
})();